import React from "react";
import TrendsSection from "./sections/TrendsSection";

const TrendsTab: React.FC<{ isGeneralMode?: boolean }> = ({ isGeneralMode }) => {
  if (!isGeneralMode) return null;
  return (
    <div className="w-full">
      <div className="border text-primary bg-[#FCFCFD] rounded-lg dark:border-[#3C5C73] dark:bg-[#3C5C73] dark:text-white px-[8px] pb-[8px] pt-1">
        <TrendsSection isGeneralMode={true} />
      </div>
    </div>
  );
};

export default TrendsTab;
